// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles_Header__PmYWn"};